var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCursorWithShadow2023(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "53px",
    height: "55px",
    viewBox: "0 0 53 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cursor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-51.7%",
    y: "-25.3%",
    width: "202.7%",
    height: "150.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cursor",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5_RGB",
    filter: "url(#filter-1)",
    transform: "translate(26.511662, 27.380941) rotate(-40.000000) translate(-26.511662, -27.380941) translate(14.011662, 2.380941)",
    stroke: "#26439B",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "21.0086679 1.61796945 24.6259256 17.577679 16.4993247 22.691237 22.5650441 32.2206113 12.3590435 36.3867519 0.625925561 26.3509301 5.35562766 22.4266844 3.13430575 10.6686771 7.97027093 10.7834829 8.30267601 10.5374857 10.2575423 0.429147625"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-2",
    points: "8.56297157 40.1092203 15.5382125 40.7504028 17.3482783 46.6942207 13.6792432 49.1092203 7.34827826 44.7468797 8.56297157 40.1092203"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorWithShadow2023);
export default __webpack_public_path__ + "static/media/cursor-with-shadow-2023.d378aa89a87e4489dae3ca74efd9ffca.svg";
export { ForwardRef as ReactComponent };